import React from 'react'
import { useLocation } from 'react-router-dom'

import { AppLocale } from '@procsea/common/utils'
import { Flag, Inline, MenuEntry, Text } from '@procsea/design-system'

import { useLocale } from 'src/hooks'

import { APP_LANGUAGES } from './appLanguages'

const changePathnameLocale = (pathname: string, newLocale: AppLocale) =>
  pathname.replace(/\w{2}/, newLocale)

export interface LanguageMenuItemProps {
  locale: AppLocale
}

const LanguageMenuItem = ({ locale }: LanguageMenuItemProps) => {
  const { pathname } = useLocation()
  const currentLocale = useLocale()

  const link = changePathnameLocale(pathname, locale)

  const language = APP_LANGUAGES[locale]

  return (
    <a data-e2e={`menu-entry-language--anchor--${locale}`} href={link} rel="noreferrer noopener">
      <MenuEntry
        data-e2e={`menu-entry-language--${locale}`}
        isActive={locale === currentLocale}
        label={
          <Inline spacing="medium" alignment="center" noWrap>
            <Flag code={language.flag} style={{ height: '0.9em' }} />
            <Text size="large">{language.label}</Text>
          </Inline>
        }
      />
    </a>
  )
}

export default LanguageMenuItem
